import apiClient from '@/services/axios'

export const getDashboardSiteManager = async (id, date, search) => {
  const res = await apiClient.get(`/siteManager/status?id=${id}`, { params: { date, search } })
  if (res) {
    return res.data
  } else {
    return []
  }
}

export const getAllSiteManagers = async (customerId, locationId) => {
  const res = await apiClient.get(`/siteManager/users/${customerId}`, {
    params: { locationId },
  })
  if (res) {
    return res.data
  } else {
    return []
  }
}
